export const findFirstIndex =
  (arr = []) =>
  (func) => {
    return arr.findIndex(func);
  };

export const findLastIndex =
  (arr = []) =>
  (func) => {
    const index = arr.slice().reverse().findIndex(func);
    if (index < 0) {
      return index;
    }
    return arr.length - 1 - index;
  };

export const uniqueInArray = (v, i, s) => s.indexOf(v) === i;
